<script setup lang="ts">
import TheHeader from "@/components/layout/TheHeader.vue"
import TheSidebar from "@/components/layout/TheSidebar.vue"
import { computed } from "vue"
import { NGrid, NGi } from "naive-ui"
import { useRoute } from "vue-router"
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core"

const breakpoints = useBreakpoints(breakpointsTailwind)
const smallerLg = breakpoints.smaller("lg")


const route = useRoute()
const isUserProfile = computed(() => route.meta.hasProfileSidebar)
</script>
<template>
	<div class="main-layout" :class="{'isMobile': smallerLg}">
		<TheHeader />
		<div class="container">
			<n-grid cols="4" :x-gap="24">
				<n-gi v-if="isUserProfile">
					<div class="profile-sidebar"></div>
					<TheSidebar />
				</n-gi>
				<n-gi :span="isUserProfile ? 3 : 4">
					<router-view v-slot="{ Component }">
						<component :is="Component" />
					</router-view>
				</n-gi>
			</n-grid>
		</div>
	</div>
</template>

<style lang="scss">
.main-layout {
	margin-top: 9.6rem;
	padding: 4.8rem 2.4rem;

	&.isMobile {
		padding: 2.4rem;
		.container {
			margin: 0;
		}
	}
}
</style>
